
import { defineComponent, reactive } from "vue";
import useRepo from "@/hooks/useRepo";
import { useRoute, useRouter } from "vue-router";
import PageControl from "@/components/PageControl.vue";

export default defineComponent({
  name: "Repository",
  components: {
    PageControl
  },
  async setup() {
    const route = useRoute();
    const router = useRouter();
    const { userRepo } = await useRepo(
      route.params.user_name as string,
      route.params.repo_name as string
    );

    const nextStep = reactive({
      action: () => {
        router.go(-1);
      },
      isDisabled: false,
      label: "Go back to User Repositories"
    });
    const previousStep = reactive({
      action: () => {
        // I decided not to go one level back but redirect to homepage
        router.push("/");
      },
      isDisabled: false,
      label: "Home"
    });
    return {
      userRepo,
      nextStep,
      previousStep
    };
  }
});
